export const validate = (values) => { // eslint-disable-line
  const errors = {};
  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./app/components/EditorAvvisi/Form/validation.js